import React from 'react';
import {
    TextInputField,
    CheckboxField,
    SwitchField,
    RadioField,
    SelectField,
    SelectMui3Field,
    SelectMui4Field,
    DateTimeField,
    DateField,
    ChipSelectField,
    AutoCompleteSelectField,
    TextSearchField,
    MuiFileInputField,
    CompetencySelectField,
    TextArea
} from './MuiFields';
import {
    HiddenField,
    FileInputField
} from './GenericFields';
import FormFieldTypes from '../../constants/FormFieldTypes';
import PropTypes from 'prop-types';
import { errorStatePropTypes, formDataPropTypes, schemaPropTypes } from '../../PropTypes/PropTypes';

export default class FieldSet extends React.Component {

    getInputComponent(field) {
        const {
            fieldClasses,
            onChange,
            onFocus,
            onBlur,
            errorState,
            formData
        } = this.props;
        let FieldComponent = null;
        let fieldError = {};

        if (!field) {
            return null;
        }

        // default fields that are used in this field set
        switch (field.type) {
            case FormFieldTypes.STRING:
                FieldComponent = TextInputField;
                break;
            case FormFieldTypes.HIDDEN:
                FieldComponent = HiddenField;
                break;
            case FormFieldTypes.CHECKBOX:
                FieldComponent = CheckboxField;
                break;
            case FormFieldTypes.CHIP_SELECT:
                FieldComponent = ChipSelectField;
                break;
            case FormFieldTypes.COMPETENCY_SELECT:
                FieldComponent = CompetencySelectField;
                break;
            case FormFieldTypes.SWITCH:
                FieldComponent = SwitchField;
                break;
            case FormFieldTypes.RADIO:
                FieldComponent = RadioField;
                break;
            case FormFieldTypes.SELECT:
                FieldComponent = SelectField;
                break;
            case FormFieldTypes.SELECT_MUI3:
                FieldComponent = SelectMui3Field;
                break;
            case FormFieldTypes.SELECT_MUI4:
                FieldComponent = SelectMui4Field;
                break;
            case FormFieldTypes.DATE_TIME:
                FieldComponent = DateTimeField;
                break;
            case FormFieldTypes.DATE:
                FieldComponent = DateField;
                break;
            case FormFieldTypes.AUTO_COMPLETE_SELECT:
                FieldComponent = AutoCompleteSelectField;
                break;
            case FormFieldTypes.TEXT_SEARCH:
                FieldComponent = TextSearchField;
                break;
            case FormFieldTypes.FILE:
                FieldComponent = FileInputField;
                break;
            case FormFieldTypes.FILE_MUI:
                FieldComponent = MuiFileInputField;
                break;
            case FormFieldTypes.TEXT_AREA:
                FieldComponent = TextArea;
                break;
            default:
                break;
        }

        // overridden field component
        if (field.component) {
            FieldComponent = field.component;
        }

        if (errorState[field.id]) {
            fieldError = {
                error: !!errorState[field.id].errorText,
                errorText: errorState[field.id].errorText
            };
        }

        if (FieldComponent) {
            return (
                <div
                    key={ field.id }
                    className={ fieldClasses.root ? fieldClasses.root : '' }
                >
                    <FieldComponent
                        onChange={ onChange }
                        onFocus={ onFocus }
                        onBlur={ onBlur }
                        { ...fieldError }
                        { ...field }
                        inputValue={ formData[field.id] }
                    />
                </div>
            );
        }

        return null;
    }

    render() {
        const {
            schema,
            fieldSetClasses,
            groupClasses
        } = this.props;
        const fields = schema.fields;

        const groupsOutput = {};
        const fieldsOutput = [];

        Object.keys(fields).forEach(key => {
            if (Object.prototype.hasOwnProperty.call(fields, key)) {
                if (fields[key] && fields[key].sectionGroup) {

                    const group = fields[key].sectionGroup;

                    // create group if it wasnt there already
                    if (!groupsOutput[group]) {
                        groupsOutput[group] = [];
                    }

                    // push to group
                    groupsOutput[group].push(fields[key]);
                } else {

                    // loose field output
                    fieldsOutput.push(fields[key]);
                }
            }
        });

        return (
            <div className={ fieldSetClasses.root ? fieldSetClasses.root : '' }>
                { Object.keys(groupsOutput).map((groupKey, index) => <section
                    key={ index }
                    id={ groupKey }
                    className={ groupClasses[groupKey] || null }
                >{ groupsOutput[groupKey].map(groupItem => this.getInputComponent(groupItem)) }
                </section>)
                }

                { fieldsOutput.map(fieldItem => this.getInputComponent(fieldItem)) }
            </div>
        );
    }
}

FieldSet.propTypes = {
    schema: schemaPropTypes.isRequired,
    fieldClasses: PropTypes.shape({
        root: PropTypes.string
    }),
    fieldSetClasses: PropTypes.shape({
        root: PropTypes.string
    }),
    groupClasses: PropTypes.object,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    errorState: errorStatePropTypes,
    formData: formDataPropTypes.isRequired
};

FieldSet.defaultProps = {
    fieldClasses: {},
    fieldSetClasses: {},
    groupClasses: {},
    errorState: {},
    formData: {}
};
